<app-dropzone
    #dropzone
    class="contest-dropzone"
    [title]="null"
    [cover]="cover"
    [preview]="true"
    (onFileDropped)="fileSelected($event)"
    (onFilePicked)="fileSelected($event)">
</app-dropzone>
